import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05ed6bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "promo--bottom py-15" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-9 text-white" }, "Why millions of users choose us", -1))
const _hoisted_3 = { class: "d-flex align-center pb-8" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "heading-3 mb-1 text-white" }
const _hoisted_6 = {
  key: 0,
  style: {"max-width":"350px","color":"#9ba1ae"},
  class: "heading-5"
}
const _hoisted_7 = {
  key: 1,
  class: "text-gray heading-5",
  style: {"max-width":"350px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@simplex.com" }, "support@mew.com", -1))

import iconFee from "@/assets/images/promo/icon-fee.png";
import iconFeeBlue from "@/assets/images/promo/icon-fee-blue.png";
import iconFeeMew from "@/assets/images/promo/icon-fee-mew.png";
import iconQuick from "@/assets/images/promo/icon-quick.png";
import iconQuickBlue from "@/assets/images/promo/icon-quick-blue.png";
import iconQuickMew from "@/assets/images/promo/icon-quick-mew.png";
import iconVerification from "@/assets/images/promo/icon-verification.png";
import iconVerificationBlue from "@/assets/images/promo/icon-verification-blue.png";
import iconVerificationMew from "@/assets/images/promo/icon-verification-mew.png";
import iconSupport from "@/assets/images/promo/icon-support.png";
import iconSupportBlue from "@/assets/images/promo/icon-support-blue.png";
import iconSupportMew from "@/assets/images/promo/icon-support-mew.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'PromoComponentThisIsWhy',
  setup(__props) {

const isEthVm = window.location.search.includes("platform=ethvm");
const isEnkrypt = window.location.search.includes("platform=enkrypt");

const promo2 = [
  {
    icon: isEthVm ? iconFeeBlue : isEnkrypt ? iconFee : iconFeeMew,
    title: "Low fees",
    description:
      "Get the most crypto for your fiat with limited fees from the provider and MEW",
  },
  {
    icon: isEthVm ? iconQuickBlue : isEnkrypt ? iconQuick : iconQuickMew,
    title: "Quick transactions",
    description: "Get crypto in your wallet in minutes",
  },
  {
    icon: isEthVm
      ? iconVerificationBlue
      : isEnkrypt
      ? iconVerification
      : iconVerificationMew,
    title: "Easy verification",
    description: "Payment is processed in a few short steps",
  },
  {
    icon: isEthVm ? iconSupportBlue : isEnkrypt ? iconSupport : iconSupportMew,
    title: "Human support",
    description: `Reach out to ${
      isEthVm ? "support@ethvm.com" : "support@enkrypt.com"
    } with any questions`,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(promo2, (p2, key2) => {
              return _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                sm: "6",
                key: key2,
                class: _normalizeClass(['justify-left', 'd-flex'])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      class: "mr-4",
                      src: p2.icon,
                      alt: "Promo"
                    }, null, 8, _hoisted_4),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(p2.title), 1),
                      (p2.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(p2.description), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createTextVNode(" Feel free to contact "),
                            _hoisted_8,
                            _createTextVNode(" should you have questions. ")
                          ]))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})